//
//
//
//
//
//
//
//
//
//
//

var BUTTON_TYPES = ['primary', 'secondary', 'danger', 'primary-outline', 'secondary-outline', 'danger-outline'];
var BUTTON_SIZES = ['sm', 'lg'];

var script = {
  name: 'PtButton',
  props: {
    variant: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: String,
      default: '',
    },
  },
  computed: {
    btnClass: function btnClass() {
      var btnClass = [];

      if (this.rounded) {
        if (this.rounded === 'circular') {
          var circularClass = this.size ? ("icon-" + (this.rounded) + "-" + (this.size)) : ("icon-" + (this.rounded));
          btnClass.push(circularClass);
        } else {
          btnClass.push(("" + (this.rounded)));
        }
      }

      if (this.isFullWidth) {
        btnClass.push('pt-btn-full');
      }

      if (this.variant.indexOf('outline') > -1) {
        btnClass.push('pt-btn-outline');
      }

      if (BUTTON_TYPES.indexOf(this.variant) > -1) {
        btnClass.push(("pt-btn-" + (this.variant)));
      }

      if (BUTTON_SIZES.indexOf(this.size) > -1) {
        btnClass.push(("pt-btn-" + (this.size)));
      }

      return btnClass;
    },
  },
  methods: {
    onClick: function onClick(event) {
      event.preventDefault();
      this.$emit('action', event);
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    {
      staticClass: "pt-btn",
      class: _vm.btnClass,
      attrs: { disabled: _vm.disabled },
      on: { click: _vm.onClick }
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Button = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//

var BUTTON_TYPES$1 = ['primary', 'secondary', 'red', 'blue', 'green', 'yellow'];
var BUTTON_SIZES$1 = ['tiny', 'sm', 'lg'];

var script$1 = {
  name: 'PtLabelButton',
  props: {
    type: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: '',
    },
  },
  computed: {
    labelBtnClass: function labelBtnClass() {
      var btnClass = [];

      if (BUTTON_TYPES$1.indexOf(this.type) > -1) {
        btnClass.push(("pt-label-btn-" + (this.type)));
        btnClass.push(("pt-btn-" + (this.type) + "-outline"));
      }

      if (BUTTON_SIZES$1.indexOf(this.size) > -1) {
        btnClass.push(("pt-btn-" + (this.size)));
      }

      return btnClass;
    },
  },
};

/* script */
            var __vue_script__$1 = script$1;
            
/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [
    _c(
      "div",
      { staticClass: "pt-label-btn", class: _vm.labelBtnClass },
      [_vm._t("default")],
      2
    )
  ])
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  var __vue_inject_styles__$1 = undefined;
  /* scoped */
  var __vue_scope_id__$1 = undefined;
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var LabelButton = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

export { Button as PtButton, LabelButton as PtLabelButton };
